export default "__VITE_ASSET__D5xyv62U__"